import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Vehicles() {
  const [branches, setBranches] = useState([]);
  useEffect(() => { api.get("/branches").then(({ data }) => setBranches(data)); }, []);
  return (
    <ResourcePage
      endpoint="/vehicles"
      testidPrefix="vehicle"
      eyebrow="Operations"
      title="Vehicle Management"
      subtitle="Fleet registry — delivery trucks, vans, pickups and executive vehicles."
      ctaLabel="Register vehicle"
      fields={[
        { name: "plate_number", label: "Plate number", required: true, placeholder: "UAX 123A" },
        { name: "type", label: "Type", type: "select", required: true,
          options: ["delivery_truck", "van", "pickup", "executive"], default: "delivery_truck" },
        { name: "make", label: "Make" },
        { name: "model", label: "Model" },
        { name: "year", label: "Year", type: "number" },
        { name: "driver", label: "Assigned driver" },
        { name: "branch", label: "Branch", type: "select", options: branches.map((b) => b.name) },
        { name: "insurance_expiry", label: "Insurance expiry", type: "date" },
        { name: "odometer", label: "Odometer (km)", type: "number" },
        { name: "status", label: "Status", type: "select", default: "active",
          options: ["active", "maintenance", "retired"] },
      ]}
      columns={[
        { key: "plate_number", label: "Plate #" },
        { key: "type", label: "Type", render: (i) => (i.type || "").replaceAll("_", " ") },
        { key: "make", label: "Make/Model", render: (i) => `${i.make || ""} ${i.model || ""}`.trim() || "—" },
        { key: "driver", label: "Driver" },
        { key: "branch", label: "Branch" },
        { key: "insurance_expiry", label: "Insurance exp." },
        { key: "status", label: "Status", render: (i) => <Badge tone={i.status === "active" ? "emerald" : i.status === "maintenance" ? "amber" : "gray"}>{i.status}</Badge> },
      ]}
      searchKeys={["plate_number", "make", "model", "driver", "branch"]}
    />
  );
}
